<template>
  <v-layout row wrap
    class="wf-justify-content-center"
  >
    <v-flex xs12>
      <Navbar
        :noBackChevron="true"
      />
    </v-flex>
    <responsive-flex>
      <v-flex xs12
        class="display-1 mt-2"
      >
        Congratulations!
      </v-flex>
      <template>
        <v-flex xs12
          class="mt-2"
        >
          Your application was approved for the credit limit:
        </v-flex>
        <v-flex xs11
          class="display-2 my-3 wf-mx-auto"
        >
          {{ selectedOffer.amount | currency }}
          <v-divider/>
        </v-flex>
        <v-flex xs12 class="my-2 px-5 text-xs-center" v-if="lender.id === 'greensky'">
          If you wish to increase your Credit Limit you can contact GreenSky at
          <a tel="866-936-0602" class="wf-link">866-936-0602</a>
        </v-flex>
      </template>
      <GreenskyResults
        v-if="lender.id === 'greensky'"
        @keepStateIntact="persistState"
      />
      <FortivaResults
        v-else-if="lender.id === 'fortiva'"
      />
    </responsive-flex>
  </v-layout>
</template>

<script>
  import Navbar from 'Components/Navbar.vue'
  import GreenskyResults from 'Components/ApplicationResultsGreensky.vue'
  import FortivaResults from 'Components/ApplicationResultsFortiva.vue'
  import { mapGetters, mapState } from 'vuex'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'

  export default {
    name: 'ApplicationResults',
    components: {
      FortivaResults,
      GreenskyResults,
      Navbar,
      ResponsiveFlex,
    },
    data () {
      return {
        keepStateIntact: false
      }
    },
    computed: {
      ...mapGetters([
        'selectedOffer'
      ]),
      ...mapState({
        lender: state => state.loanApplication.lender,
        loanAmount: state => state.loanApplication.loanAmount,
        paceEligibility: state => state.loanApplication.paceEligibility,
      })
    },
    methods: {
      persistState () {
        this.keepStateIntact = true
      }
    },

    
  }
</script>

<style scoped lang="scss">
  .recalculate-container {
    width: 70%;
  }

  .recalculate-input {
    font-size: 1.8em;
  }
</style>
